import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookAwardFlightsComponent } from './book-award-flights.component';
// import { TAPBookAwardFlightsComponent } from './book-award-flights.tap.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ErrorPageModule } from '../error-page/error-page.module';
import { SharedModule } from '@ibe.components/shared/shared.module';
import { InputsModule } from '@ibe.components/common/inputs/inputs.module';
/* REPLICATED FILES */
import { INDRABookAwardFlightsComponent } from './book-award-flights.indra.component';

@NgModule({
	declarations: [BookAwardFlightsComponent, INDRABookAwardFlightsComponent],
	imports: [
		CommonModule,
		SharedModule,
		InputsModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		ErrorPageModule
	], exports: [
		INDRABookAwardFlightsComponent
	]
})
export class BookAwardFlightsModuleModule { }
